import React, { useMemo } from "react";


const CategoryCellRenderer = (props) => {
  const imageForcolour = (c) => {
    if(c==='inspection') return "Ispezione";
    if(c==='maintenance') return "Manutenzione";
    if(c==='restoration') return "Ripristino";
  }

  const colour = useMemo(() => imageForcolour(props.value), [props.value]);
  console.log(colour);

  return (
    <div className="category-renderer">
        <span style={{width:"95px"}}>
         <div className={colour}>
           {colour}
         </div>
        </span>
    </div>
  );
};


export default CategoryCellRenderer;
